var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKatalonStudioIntegration({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_319_6385)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_319_6385)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.9996 19.9993H15.9996V28H23.9996V19.9993Z",
    fill: "#19D89F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9989 4L8 12.0011V20H15.9989L24 12.0011V4H15.9989Z",
    fill: "black"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_319_6385"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_319_6385"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 24,
    fill: "white",
    transform: "translate(8 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKatalonStudioIntegration);
export default __webpack_public_path__ + "static/media/katalon-studio-integration.0e176dbacdf63a886754c78828c7f828.svg";
export { ForwardRef as ReactComponent };